import { of as observableOf, Observable } from 'rxjs';
import { tap, switchMap, filter, map } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { SurveyFilter } from '../survey-list/survey.filter.model';
import {
  ActivatedRoute,
  Router,
} from '../../../../node_modules/@angular/router';
import { SurveyService } from '../../services/survey.service';
import { ReportingService } from '../../services/reporting.service';

@Component({
  selector: 'app-my-page',
  templateUrl: './my-page.component.html',
  styleUrls: ['./my-page.component.scss'],
})
export class MyPageComponent implements OnInit {
  isSelfassessmentTab: boolean;
  isReportOpened: boolean;
  isSurveyOpen: boolean;
  surveyFilter: any = SurveyFilter;
  surveyProcessName: string;
  isPdfDownloadingInProgress = false;
  isDetailedReportClicked = false;
  private readonly decimailScsle = 10;
  private processId: number;
  private appraiseeId: number;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private surveyService: SurveyService,
    private reportingService: ReportingService
  ) {}

  ngOnInit() {
    this.getRouteDataOnLoad();
    this.router.events
      .pipe(
        filter(
          (x) => x['state'] && x['state'].root && x['state'].root.children
        ),
        map((x) => {
          const childrenRoute: ActivatedRoute = [
            ...x['state'].root.children,
          ].shift();
          return childrenRoute && childrenRoute.firstChild
            ? childrenRoute.firstChild
            : observableOf({});
        })
      )
      .subscribe((x) => {
        if (x && x['routeConfig']) {
          this.isSelfassessmentTab = x['routeConfig'].path.includes(
            'self-assessment'
          );
          this.isReportOpened = x['url'].some((p) => p.path === 'report');
          this.processId = +x['params'].processId;
          this.appraiseeId = +x['params'].appraiseeId;
        }
      });
    this.route.firstChild.paramMap
      .pipe(
        tap((params) => {
          this.isSelfassessmentTab =
            parseInt(params.get('currentFilter'), this.decimailScsle) ===
            SurveyFilter.ByAppraisee
              ? true
              : false;
        }),
        switchMap(() => this.surveyService.selfAssesmentSurveyName$)
      )
      .subscribe((x) => {
        this.surveyProcessName = x;
        this.isSurveyOpen = x.length > 0 ? true : false;
      });
    this.reportingService.individualReportDownloaded$.subscribe(
      (x) => (this.isPdfDownloadingInProgress = !x)
    );
    this.reportingService.summaryReportDownloaded$.subscribe(
      (x) => (this.isPdfDownloadingInProgress = !x)
    );
    this.reportingService.detailedReportClicked$.subscribe(
      (x) => (this.isDetailedReportClicked = x)
    );
  }

  downloadIndividualPdf() {
    this.reportingService.onIndividualPdfDownloadClick();
    this.isPdfDownloadingInProgress = true;
  }

  downloadSummaryPdf() {
    this.reportingService.onSummaryPdfDownloadClick();
    this.isPdfDownloadingInProgress = true;
  }

  getButtonTitle() {
    return this.isDetailedReportClicked
      ? 'lang.reporting.showIndividualReport'
      : 'lang.reporting.showDetailedReport';
  }

  navigateToIndividualReport() {
    this.isDetailedReportClicked = !this.isDetailedReportClicked;
    this.reportingService.swipeReport(this.isDetailedReportClicked);
  }

  navigateToSurvey() {
    this.isSelfassessmentTab = true;
    this.isSurveyOpen = false;
  }

  navigateToMyPage() {
    this.isSelfassessmentTab = false;
    this.isSurveyOpen = false;
  }

  private getRouteDataOnLoad() {
    const briefReportRoute = this.route.snapshot.children.find((x) =>
      x.url.some((p) => p.path === 'report')
    );
    if (!briefReportRoute) {
      return;
    }
    this.isReportOpened = true;
    this.processId = +briefReportRoute.params.processId;
    this.appraiseeId = +briefReportRoute.params.appraiseeId;
  }
}
